import { showWarningMessage } from '../../../_component/MessageSnack';
import axiosInstance from '../../../_config/AxiosInstance';
import config from '../../../_config/config';
import { userCompanyBookmarkConstants } from '../../constant';

export const fetch_user_bookmark_companies_action = (status) => async (dispatch) => {
  dispatch({
    type: userCompanyBookmarkConstants.FETCH_USER_COMPANYS_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.get(config.bookmarks.company);
    if (response.status) {
      let data = response.data;
      dispatch({
        type: userCompanyBookmarkConstants.FETCH_USER_COMPANYS_ACTION_SUCCESS,
        payload: { data: data.data, status },
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: userCompanyBookmarkConstants.FETCH_USER_COMPANYS_ACTION_FAILURE,
      payload: e?.error,
    });
    showWarningMessage(e.error || e.message);
    
  }
};

export const update_user_bookmark_company_action = (id, status) => async (dispatch) => {
  dispatch({
    type: userCompanyBookmarkConstants.UPDATE_USER_COMPANY_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.put(`${config.bookmarks.company}/${id}`, status);
    if (response.status) {
      let data = response.data;
      dispatch({
        type: userCompanyBookmarkConstants.UPDATE_USER_COMPANY_ACTION_SUCCESS,
        payload: data.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: userCompanyBookmarkConstants.UPDATE_USER_COMPANY_ACTION_FAILURE,
      payload: e?.error,
    });
    showWarningMessage(e.error || e.message);
    
  }
};

// action to create a new company
export const create_user_bookmark_company_action = (data) => async (dispatch) => {
  dispatch({
    type: userCompanyBookmarkConstants.CREATE_USER_COMPANY_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(config.bookmarks.company, data);
    if (response.status) {
      let data = response.data;
      dispatch({
        type: userCompanyBookmarkConstants.CREATE_USER_COMPANY_ACTION_SUCCESS,
        payload: data.data,
      });
      return data.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: userCompanyBookmarkConstants.CREATE_USER_COMPANY_ACTION_FAILURE,
      payload: e?.error,
    });
    showWarningMessage(e.error || e.message);
    return null;
  }
};

export const fetch_user_company_details_bookmark_action = (id) => async (dispatch) => {
  dispatch({
    type: userCompanyBookmarkConstants.FETCH_USER_COMPANY_DETAILS_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.get(`${config.bookmarks.company}/${id}`);
    if (response.status) {
      let data = response.data;
      dispatch({
        type: userCompanyBookmarkConstants.FETCH_USER_COMPANY_DETAILS_ACTION_SUCCESS,
        payload: data.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: userCompanyBookmarkConstants.FETCH_USER_COMPANY_DETAILS_ACTION_FAILURE,
      payload: e?.error,
    });
    showWarningMessage(e.error || e.message);
    
  }
};

export const delete_user_company_details_bookmark_action = (id) => async (dispatch) => {
  dispatch({
    type: userCompanyBookmarkConstants.DELETE_USER_COMPANY_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.delete(`${config.bookmarks.company}/${id}`);
    if (response.status) {
      let data = response.data;
      dispatch({
        type: userCompanyBookmarkConstants.DELETE_USER_COMPANY_ACTION_SUCCESS,
        payload: data.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: userCompanyBookmarkConstants.DELETE_USER_COMPANY_ACTION_FAILURE,
      payload: e?.error,
    });
    showWarningMessage(e.error || e.message);
    
  }
};
